import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from './Base';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function HitGameEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const period = periods[event.period].name;
  const winner = players[event.winner];
  const loser = players[event.loser];
  const team = teams[winner.team].id

  return (
    <Base
      time={event.second}
      period={period}
      team={team}
      type="Hit"
    >
      <Typography variant="body2">
        <span className={classes.bold}>{loser.name}</span>
        {' '}is hit by{' '}
        <span className={classes.bold}>{winner.name}</span>
        {event.turnover && ' and loses the puck'}
      </Typography>
    </Base>
  )
}

export default HitGameEvent;
